import createReducer from 'lib/reducers/createReducer'
import {flashTypes} from 'actions/types'

const INITIAL_STATE = {}
export default createReducer(INITIAL_STATE, {
  [flashTypes.SET_FLASH]: (_, action) => action.payload,
  [flashTypes.CLEAR_FLASH]: () => INITIAL_STATE
})
